<template>
  <b-col cols="6" lg="4"  class="p-0 mb-3 pl-1 pr-1">
      <b-card 
      v-bind:img-src="getImage"
      img-bottom
      overlay
      border-variant="white"
      variant="white"     
      v-on:click="go('/app/'+ ShopProductItem.type +'/' + ShopProductItem.id)">

        <div class="half-circle" alt=""></div>
        <div v-html="getTitle" class="product-description text-uppercase"></div>
      
    </b-card>
  </b-col>
</template>

<script>
export default {
  name: "ShopProductItem",
  props: ["ShopProductItem", "CardOptions", "ShopCategory"],
  methods: {
    go: function(route) {
      /* go to category... */
      // console.log(route);
      this.$router.push(route);
    }
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getTitle() {
      return this.ShopProductItem.title;
    },
    getDescription() {
      return this.ShopProductItem.shortDescription;
    },
    getPriceLabel() {
      return this.ShopProductItem.shortPriceInfo;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getImage() {
      // Quickfix: FIXME
      return (
        this.$store.getters.getWebServerBaseUrl + this.ShopProductItem.images[0]
      );
    },   
    getRoute(){
      // use TYPE as path
      return '/app/'+ this.ShopProductItem.type +'/'+this.ShopProductItem.id;
    }
  },
  mounted(){
   // console.log(this.ShopProductItem);
    
  }
};
</script>
